import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgPlus = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m.667-12.667V6.667h-1.334v4.666H6.667v1.334h4.666v4.666h1.334v-4.666h4.666v-1.334z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgPlus);
export default Memo;
